import { Chip, Stack, Typography } from '@mui/material';

import { say } from '@/james-playground/aa-family-claim/claim/asks';
import { entry } from '@/james-playground/aa-family-claim/claim/registry';
import { AMOUNT } from '@/james-playground/aa-family-claim/claim/cards/cards.content';
import {
  CardShell,
  useDraft,
} from '@/james-playground/aa-family-claim/claim/cards/parts';
import { type CardProps } from '@/james-playground/aa-family-claim/claim/cards/types';
import {
  countOf,
  str,
} from '@/james-playground/aa-family-claim/claim/cards/values';

const WEEK = [0, 1, 2, 3, 4, 5, 6, 7];

/**
 * Days or nights a week, 0 to 7, as large chips: the form's box takes a
 * number, so the answer is one. A proposal like "every day" arrives as 7.
 */
const AmountCard = ({ ask, facts, voice: v, onSubmit, onSkip }: CardProps) => {
  const id = ask.entries[0];
  const { draft, set } = useDraft(ask, facts);
  const unit = entry(id).answerType === 'nights_per_week' ? 'nights' : 'days';
  const n = countOf(str(draft[id]));
  const name = (k: number) => (k === 1 ? AMOUNT.one[unit] : AMOUNT[unit]);

  return (
    <CardShell
      label={say(ask.title, v)}
      ready={n !== undefined}
      onSkip={onSkip}
      onContinue={() =>
        n !== undefined &&
        onSubmit(
          { [id]: String(n) },
          n === 7 ? AMOUNT.every[unit] : `${n} ${name(n)}`,
        )
      }
    >
      <Stack spacing={1}>
        <Stack
          sx={{ flexWrap: 'wrap', gap: 1 }}
          direction='row'
          role='group'
          aria-label={say(ask.prompt, v)}
        >
          {WEEK.map((k) => (
            <Chip
              key={k}
              label={String(k)}
              clickable
              aria-pressed={n === k}
              aria-label={`${k} ${name(k)}`}
              variant={n === k ? 'filled' : 'outlined'}
              color={n === k ? 'primary' : 'default'}
              onClick={() => set(id, String(k))}
              sx={{ minWidth: 52, height: 52, borderRadius: 26 }}
            />
          ))}
        </Stack>
        <Typography variant='body2' aria-hidden>
          {AMOUNT[unit]}
        </Typography>
      </Stack>
    </CardShell>
  );
};

AmountCard.displayName = 'AmountCard';
export default AmountCard;
